/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.registerPush'

export { $nsid }

/** Register to receive push notifications, via a specified service, for the requesting account. Requires auth. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    serviceDid: l.string({ format: 'did' }),
    token: l.string(),
    platform: l.string<{ knownValues: ['ios', 'android', 'web'] }>(),
    appId: l.string(),
    ageRestricted: l.optional(l.boolean()),
  }),
  l.payload(),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
